import { folderPermissionsRetrieveFailed } from './getFolderPermissionsOrchestrator.locstring.json';
import { cantCompleteRequestText } from 'owa-locstrings/lib/strings/cantcompleterequesttext.locstring.json';
import loc, { format } from 'owa-localize';
import { orchestrator } from 'satcheljs';
import {
    getFolderTable,
    getFolderPermissionsSuccess,
    getFolderPermissionsFailed,
} from 'owa-folders';
import { getStore } from '../store/store';
import {
    setFolderPermissionsLoader,
    updateFolderPermissionsInUIStore,
    showHideFolderPermissionDialog,
} from '../actions/internalActions';

import { confirm } from 'owa-confirm-dialog';

/**
 * This orchestrator watches getFolderPermissionsSuccess action from owa-folders.
 * It will fire two actions to update folder permissions in UI store and to hide loader.
 */
export const getFolderPermissionsSuccessOrchestrator = orchestrator(
    getFolderPermissionsSuccess,
    () => {
        const { folderId, showFolderPermissionsDialog } = getStore();
        // Orchestrator should not permform any task, if permission dialog is not open.
        if (!showFolderPermissionsDialog) {
            return;
        }
        const { PermissionSet } = getFolderTable().get(folderId);

        // Deep clone the permissions list so that original list in folder store will not be impacted.
        const permissions = PermissionSet.Permissions.map(permission => ({ ...permission }));
        updateFolderPermissionsInUIStore(permissions);

        // Dispatching action for hiding the loader
        setFolderPermissionsLoader(false);
    }
);

/**
 * This orchestrator watches getFolderPermissionsFailed action from owa-folders.
 * It will fire two actions to close folder permissions dialog and to show error dialog.
 */
export const getFolderPermissionsFailedOrchestrator = orchestrator(
    getFolderPermissionsFailed,
    () => {
        const { folderId, showFolderPermissionsDialog } = getStore();
        // Orchestrator should not permform any task, if permission dialog is not open.
        if (!showFolderPermissionsDialog) {
            return;
        }
        const { DisplayName } = getFolderTable().get(folderId);
        showHideFolderPermissionDialog(folderId, false /* Should show */);

        // Show error dialog.
        const messageSubText = format(loc(folderPermissionsRetrieveFailed), DisplayName);
        confirm(loc(cantCompleteRequestText), messageSubText, false, { hideCancelButton: true });
    }
);
